import type { BaseTranslation } from '../i18n-types';

export const unauthorizedStart = {
    title: 'Welcome to Random Video Chat',
    subtitle: '100% anonymous video sex chat where men are connected with real women. Jump head-on and have a fun and stimulating conversation right now!',
    buttonStartLabel: 'Start chat',
} satisfies BaseTranslation;
